import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ff-content',
  templateUrl: './content.component.html'
})
export class ContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/manuel/Sites/doxasoft/fenyofarm/csemete/src/app/content/content.component.ts